import UserEmailEditStep from './UserEmailEditStep';
import { withPopup } from './Utils';

export default withPopup(UserEmailEditStep);
